let env = window.config.env
let apiUrl = window.config.apiUrl
let clientUrl = window.config.clientUrl

module.exports = {
  CLIENT_ID: `C64E2AB621614CBD89DA89AB153B1B68`, //@ RP INNOTECH RECEIVER - NEW CUSTOM
  DIRECT_URI: `https://9fd43efc.ngrok.io`,
  REDIRECT_URI: `https://9fd43efc.ngrok.io/verified`,
  PROXY_URI: `https://cors-anywhere.herokuapp.com/`,
  SCOPE: `openid profile email accounting.transactions accounting.attachments offline_access accounting.settings accounting.journals.read`,
  STATE: `F474L15`,
  XERO_TOKEN_ENDPOINT: `https://identity.xero.com/connect/token`,
  TENANT_CONNECTION_ENDPOINT: `https://api.xero.com/connections`,
  LOCAL_ENDPOINTS: {
    HOST: `${clientUrl}/`,
    HOST_VERIFIED: `${clientUrl}/verified`,
    getClientID: `${apiUrl}/getClientID`,
    buildURL: `${apiUrl}/buildURL`,
    getAuthorizationTokens: `${apiUrl}/getAuthorizationTokens`,
    getConnections: `${apiUrl}/getConnections`,
    getBankTransactions: `${apiUrl}/getBankTransactions`,
    getCreditNotes: `${apiUrl}/getCreditNotes`,
    getInvoices: `${apiUrl}/getInvoices`,
    getJournals: `${apiUrl}/getJournals`,
    getManualJournals: `${apiUrl}/getManualJournals`,
    getTransactionsCount: "${apiUrl}/getTransactionsCount",
    getPayments: `${apiUrl}/getPayments`,
    getProfitAndLoss: `${apiUrl}/getProfitAndLoss`,
    createCSVBankTransactions: `${apiUrl}/createCSVBankTransactions`,
    createCSVInvoices: `${apiUrl}/createCSVInvoices`,
    createCSVManualJournals: `${apiUrl}/createCSVManualJournals`,
    getOrganisationName: `${apiUrl}/getOrganisationName`,
    createMultipleCSVInvoices: `${apiUrl}/createMultipleCSVInvoices`,
    createMultipleCSVBankTransactions: `${apiUrl}/createMultipleCSVBankTransactions`,
    createMultipleCSVManualJournals: `${apiUrl}/createMultipleCSVManualJournals`,
    createMultipleCSVOrganisations: "${apiUrl}/createMultipleCSVOrganisations",
    createMultipleCSVPayments: "${apiUrl}/createMultipleCSVPayments",
    createMultipleCSVJournals: "${apiUrl}/createMultipleCSVJournals",
    createMultipleCSVCreditNotes: "${apiUrl}/createMultipleCSVCreditNotes",
    storeXeroResponseCode: `${apiUrl}/storeXeroResponseCode`,
  }
}
